<template>
  <div class="pc-search">
    <el-form class="pc-search-main-formOne" :model="keywordData" :inline="true">
      <el-form-item label="名称" class="title">
        <el-input
          v-model="keywordData.name_keyword"
          placeholder=""
        ></el-input>
      </el-form-item>
      <el-form-item label="主办方" placeholder="未选择" class="series">
        <el-select
          clearable
          filterable
          v-model="keywordData.host_organization_id"
          placeholder="未选择"
        >
          <el-option
            v-for="(item, key) in organizationList"
            :label="item.chinese_name"
            :value="item.id"
            :key="key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态" placeholder="状态" class="status">
        <el-select v-model="keywordData.status" placeholder="有效" clearable>
          <el-option label="有效" value="1">有效</el-option>
          <el-option label="无效" value="0">无效</el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <button class="pc-search-btn" @click="search">筛选</button>
  </div>
</template>

<script>
import {
organizationDropDown_Api
} from "@/apis/exhibition.api";
export default {
  data() {
    return {
      keywordData: {
        id: null,
        name_keyword:"",
        status: null,
        host_organization_id:null
      },
      organizationList: [],
    };
  },
  mounted() {
    this.getOrganizations();
  },
  methods: {
    getOrganizations() {
      organizationDropDown_Api().then((res) => {
        this.organizationList = res.data;
      });
    },
    search() {
      this.$emit("search", this.keywordData);
    },
  },
};
</script>
<style lang="scss" scoped>
.pc-search {
  @include table-search;
  .title {
    width: 400px;
  }
  .number {
    width: 300px;
    /deep/ .el-input-number {
      width: 190px;
    }
  }
  .keyword {
    width: 400px;
    /deep/ .qh-tag {
      line-height: 24px;
    }
  }
  .teacher {
    width: 300px;
    /deep/ .el-autocomplete {
      width: 190px;
    }
  }
  .series {
    width: 320px;
  }
  .status {
    width: 200px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/exhibition/component/ExhibitionSearch.vue